module.exports = __webpack_public_path__ + "static/media/reinspection-report.23d7ef6b.webp";